function pageHeader() {
  return {
    template: require('./esp.pageHeader.html')
  };
};
export default pageHeader;


// WEBPACK FOOTER //
// ./src/login/header/esp.pageHeader.js